import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import "./style.css";
import { configuration } from "../appConfig";
import { updateJsonData } from "../redux/actions/updateJsonData";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CarDentPositionable extends Component {
  state = {
    data: {},
    words: {},
    lang: "En",
    dentPositions: [],
    fullData: {} // Assuming fullData is part of the state
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  componentDidMount() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        const dentPos =
          r.data.Dents &&
          r.data.Dents.length &&
          r.data.Dents.filter((r) => r.Part == this.props.part)[0] && r.data.Dents.filter((r) => r.Part == this.props.part)[0].DentPos;
        this.setState({ dentPositions: dentPos, fullData: r.data }); // Assuming fullData is part of the data received
      }
    });
    this.getLang();
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  roundUpToNearest10 = (value) => {
    return Math.ceil(value / 10) * 10;
  }

  updateReduxJson = () => {
    const { fullData, dentPositions } = this.state;

    let totalSum = 0;
    dentPositions.forEach((r) => {
      totalSum += parseFloat(r.DiaMm);
    });
    const total = this.roundUpToNearest10(totalSum / (dentPositions.length + 1));

    // Update the AvgDiaMm key
    fullData.Dents.forEach((dent) => {
      if (dent.Part === this.props.part) {
        dent.AvgDiaMm = total;
      }
    });

    // Other update logic here

    this.setState({ fullData });
    this.props.updateJsonData(fullData);
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const { dentPositions } = this.state;
    const { part } = this.props;

    let totalSum = 0;
    dentPositions && dentPositions.length > 0 && dentPositions.forEach((r) => {
      totalSum += parseFloat(r.DiaMm);
    });
    const total = this.roundUpToNearest10(totalSum / (dentPositions && dentPositions.length > 0 && dentPositions.length + 1));

    return (
      <div className="row m-0 text-muted hide-report car-dents-position-table">
        <div className="table-responsive">
          <table className="table table-bordered table-striped dent-table-2d">
            <thead>
              <tr style={{ textAlign: "center" }}>
                <th>Sn</th>
                <th>X</th>
                <th>Y</th>
                <th>{this.lang("Size")}</th>
              </tr>
            </thead>
            <tbody>
              {dentPositions && dentPositions.length ? (
                dentPositions.map((r, i) => {
                  const diaMmValue = partnerId === '10-200410-2' || partnerId === '10-200410' ? parseFloat(r.DiaMm * 0.0393701).toFixed(2) : parseInt(r.DiaMm);

                  return (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{i + 1}</td>
                      <td>{parseInt(r.X)}</td>
                      <td>{parseInt(r.Y)}</td>
                      <td>{diaMmValue}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4}>{this.lang("No Dent Data Found")}</td>
                </tr>
              )}
              {dentPositions && dentPositions.length ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "right" }}>Total:</td>
                  <td>{total}</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};

export default connect(mapStateToProps, { updateJsonData })(CarDentPositionable);
